// Applies one Debug overrides file. Bundled builds define build_config as a constant (build.js --config,
// and the validator lambda), so esbuild drops the other branches and never bundles their files.
// debug.local.ts is optional: build.js sets 'none' when it's missing, and unbundled runs (tsc + node)
// leave build_config unset and skip it if it isn't there. Release and playtest files must exist.
if (process.env.build_config === 'release') require('./debug.release');
else if (process.env.build_config === 'playtest') require('./debug.playtest');
else if (process.env.build_config === 'local') require('./debug.local');
else if (process.env.build_config === undefined) requireLocalIfPresent();

function requireLocalIfPresent() {
	let localPath: string | undefined;
	try {
		localPath = require.resolve('./debug.local');
	}
	catch (e) {
		return;
	}
	require(localPath);
}
